'use client';

import { Default_Image, base64Image } from '@/constants';
import Image from 'next/image';
import { getYoutubeIdFromUrl } from '@/utils/helper';
import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

const ReactPlayer = dynamic(() => import('react-player/youtube'), { ssr: false });

const CollageVideo = ({ source }: { source: string }) => {
  const [mounted, mount] = useState(false);
  const [muted, mute] = useState(true);
  const [poster, showPoster] = useState(true);
  const [playing, setPlaying] = useState(true);
  //const windowFocused = useTabFocus();
  let timeOutRef = useRef<NodeJS.Timeout | null>(null);
  // useEffect(() => {
  //   console.log(windowFocused, 'windowFocused');
  //   if (!windowFocused) {
  //     showPoster((s) => true);
  //   } else {
  //     clearTimeout(timeOutRef.current as NodeJS.Timeout);
  //     timeOutRef.current = setTimeout(() => {
  //       showPoster(false);
  //     }, 3000);
  //   }
  // }, [windowFocused]);
  useEffect(() => {
    mount(true);
    return () => mount(false);
  }, []);

  const youtubeId = getYoutubeIdFromUrl(source);

  return (
    <>
      <div className="relative h-full w-full bg-black">
        {mounted && playing && (
          <ErrorBoundary
            onError={(error) => {
              console.error('CollageVideo: ReactPlayer error', error);
            }}
            fallback={null}
          >
            <ReactPlayer
              className="video-background collage-video pointer-events-none !h-full !w-full"
              url={source}
              muted={muted}
              loop={true}
              playing={true}
              onPlay={() => {
                console.log('playing');
                clearTimeout(timeOutRef.current as NodeJS.Timeout);
                timeOutRef.current = setTimeout(() => {
                  showPoster(false);
                }, 3000);
              }}
              onStart={() => {
                console.log('started');
                clearTimeout(timeOutRef.current as NodeJS.Timeout);
                timeOutRef.current = setTimeout(() => {
                  showPoster(false);
                }, 3000);
              }}
              onEnded={() => {
                console.log('ended');
                showPoster((s) => true);
              }}
              // onBuffer={() => {
              //   console.log('buffer');
              //   showPoster((s) => true);
              // }}
              onPause={() => {
                console.log('paused');
                showPoster((s) => true);
                // setPlaying((s) => false);
                // setTimeout(() => {
                //   showPoster((s) => false);
                //   setPlaying((s) => true);
                // }, 100);
              }}
              config={{
                playerVars: { showinfo: 0, disablekb: 0 },
              }}
            />
          </ErrorBoundary>
        )}
        <Image
          src={youtubeId ? `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg` : Default_Image}
          alt="video"
          className={`absolute inset-0 z-10 h-full w-full transition-opacity duration-500 ${poster ? '' : 'opacity-0'}`}
          unoptimized={true}
          fill
          loading="eager"
          blurDataURL={base64Image}
          placeholder="blur"
          style={{
            objectFit: 'cover',
          }}
          priority={true}
        ></Image>
      </div>
      <style jsx global>{`
        .video-background {
          position: relative;
        }

        .video-background iframe {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 120% !important;
          height: 120% !important;
          transform: translate(-50%, -50%);
        }

        @media (max-width: 768px) {
          .video-background iframe {
            width: 126% !important;
            height: 126% !important;
          }
        }
      `}</style>
    </>
  );
};

export default CollageVideo;
